// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"97263e27","453":"17bfd978","732":"3c936d3d","977":"3ea6ff10"}[chunkId] + ".chunk.js";
};